<template>
	<div class="fuel container-fluid py-3">
		<div class="row">
			<div class="col-md-12 p-0">
				<div class="row mb-2" style="padding:0px 10px;" onclick="window.open('/satgas','_self')" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2022040002_1') != -1">
					<div class="col-md-12 banner_satgas">
						{{ this.satgasTitle}}
					</div>
				</div>


				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020060007_1') != -1">
					<OverviewBright />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020060007_1') != -1">
					<OverviewCafe />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewLPG />
				</div>
				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewNFR />
				</div>
				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewFuel />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewFuelCoco />
				</div>
				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewFuelKso />
				</div>
				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewFuelTac />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewCustomer />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewMaintenance />
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020040002_1') != -1">
					<OverviewSupport v-if="false"/>
				</div>

				<div class="row" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2020070004_1') != -1">
					<OverviewFinance />
				</div>

				<div class="row col-md-12" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2022120002_1') != -1">
					{{
						this.$router.push('satgas-monitor')
					}}
				</div>

				<div class="row col-md-12" v-if="$store.getters.getLoginInfo.userroles.indexOf('MOD2022120003_1') != -1">
					{{
						this.$router.push('/satgas/report').catch(err => {}) /*this.$router.push('satgas-cnt')*/
					}}
				</div>

				<div class="row col-md-12" v-if="this.userRolesList.length == 2 && $store.getters.getLoginInfo.userroles.indexOf('MOD2022040002_1') != -1">
					{{
						this.$router.push('satgas')
					}}
				</div>

				<div class="row col-md-12" v-if="this.userRolesList.length == 2 && $store.getters.getLoginInfo.userroles.indexOf('MOD2023120009_1') != -1">
					{{
						this.$router.push('overview-cnt')
					}}
				</div>

				<Footer/>
			</div>
		</div>
	</div>
</template>

<script>
import OverviewCustomer from '@/views/pages/OverviewCustomer.vue'
import OverviewFuel from '@/views/pages/OverviewFuel.vue'
import OverviewFuelCoco from '@/views/pages/OverviewFuelCoco.vue'
import OverviewFuelKso from '@/views/pages/OverviewFuelKso.vue'
import OverviewFuelTac from '@/views/pages/OverviewFuelTac.vue'
import OverviewBright from '@/views/pages/OverviewBright.vue'
//import OverviewBrightPertumbuhan from '@/views/pages/OverviewBrightPertumbuhan.vue'
import OverviewLPG from '@/views/pages/OverviewLPG.vue'
import OverviewNFR from '@/views/pages/OverviewNFR.vue'
import OverviewSupport from '@/views/pages/OverviewSupport.vue'
import OverviewFinance from '@/views/pages/OverviewFinance.vue'
import OverviewCafe from '@/views/pages/OverviewCafe.vue'
import OverviewMaintenance from '@/views/pages/OverviewMaintenance.vue'
import Footer from '@/views/Footer.vue'
import { AxiosWithJar, Config} from '@/utility.js'

export default{
	components:{
		OverviewCustomer,
		OverviewFuel,
		OverviewBright,
		OverviewLPG,
		OverviewNFR,
		OverviewSupport,
		OverviewFinance,
		OverviewCafe,
		OverviewMaintenance,
		Footer,
		OverviewFuelCoco,
		OverviewFuelKso,
		OverviewFuelTac,
	},
    mounted() {

		this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'

		let userRoles = String(this.$store.getters.getLoginInfo.userroles); //",MOD2022040002_1";
		this.userRolesList = userRoles.split(',');

		this.getSatgasTitle();
		//console.log(this.userRolesList.length)
    },
	data(){
		return {
			satgasTitle: 'DASHBOARD SATGAS',
			userRolesList: [],
		}
	},
    methods:{
		async getSatgasTitle() {
			//GET SATGAS TITLE
			let url =Config().apiURL + '/v1/fuel2/satgastitle?'
			AxiosWithJar().get(url)
			.then((response)=>{
				this.satgasTitle = response.data.data[0].Value;
			})
		},
	}
}

</script>
<style>
.banner_satgas {
	background-color: #ffff66;
	color: #000000;
	font-weight: bold;
	padding: 10px;
	cursor: pointer;
	border-radius:5px;
}
</style>

